import { useCloudFunction } from './useCloudFunction';
import { dateToNs, nsToDate } from './timestampUtils';
import type { AccountPortfolio } from '../types';
import type { Interval } from '../pages/portfolio/intervalDefaults';

type RawPortfolioRow = Omit<AccountPortfolio, 'timestamp'> & { timestamp: string };

export function useAccountPortfolios(
    accountId: string | null,
    from: Date,
    to: Date,
    interval: Interval,
): { data: AccountPortfolio[]; loading: boolean; error: Error | null } {
    const params = accountId ? {
        accountId,
        from: dateToNs(from),
        to: dateToNs(to),
        interval,
    } : null;

    return useCloudFunction<RawPortfolioRow, AccountPortfolio>(
        'loadAccountPortfolios',
        params,
        (rows) => rows
            .map((row) => ({
                ...row,
                timestamp: nsToDate(row.timestamp),
            })),
    );
}
